import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import moment from 'moment';

import { BaseService } from './baseservice';
import { FlowItemModel, FlowItemViewModel } from '../models/FlowItemModel';
import { FlowFilterModel } from '../models/FlowFilterModel';
import { ReportViewModel } from '../models/ReportModels';
import { PlayerFavouriteViewModel } from '../models/PlayerFavouriteModels';
import { ScoutingActivityStatsViewModel } from '../models/ScoutingActivityStatsViewModel';
import { CountItemModel } from '../models/CountItemModel';




@Injectable({
  providedIn: 'root'
})
export class ScoutingFlowService extends BaseService {

  constructor(private http: HttpClient) {
    super();
   }
   
   getAllReports(): Observable<FlowItemModel[]>{
    var startDate: String;
    startDate = moment().add(1,'days').format("YYYY-MM-DD");
    var endDate = moment().add(-4,'months').format("YYYY-MM-DD");
    let ret = this.http.get<any[]>(this.rootUrl + '/api/scoutingflow/all/' + endDate +'/' + startDate);
    
    return ret;
  }

  searchFlow(searchText: string): Observable<FlowItemModel[]> {
    const filter: FlowFilterModel = {
      SearchText: searchText,
      PlayerLastName: '',
      PlayerFirstName: '',
      maxHits: 50
    };
    return this.http.post<FlowItemModel[]>(this.rootUrl + '/api/scouting/flow', filter);
  }

  getAllByGame(gameId: string): Observable<FlowItemModel[]> {
    let ret = this.http.get<FlowItemModel[]>(this.rootUrl + '/api/scoutingflow/game/' + gameId);
    return ret;
  }

  getReport(_reportId: string): Observable<ReportViewModel>{
    let ret = this.http.get<ReportViewModel>(this.rootUrl + '/api/report/' + _reportId);
    return ret;
  }

  getFavouritesFlow(noOfDaysBack: number = 7): Observable<PlayerFavouriteViewModel[]>{
    let ret = this.http.get<PlayerFavouriteViewModel[]>(this.rootUrl + '/api/scoutingflow/favourites/' + noOfDaysBack);
    return ret;
  }

  getScoutingActivityStats(timeUnit: string, timeValue: number): Observable<ScoutingActivityStatsViewModel> {
    let ret = this.http.get<ScoutingActivityStatsViewModel>(this.rootUrl + '/api/scoutingflow/stats/' + encodeURIComponent(timeUnit) + '/' + timeValue);
    return ret;
  }

  getScoutingSimpleActivityStats(): Observable<CountItemModel[]> {
    return this.http.get<CountItemModel[]>(this.rootUrl + '/api/scoutingflow/seasonstats');
  }

  getFlowByGame() {

  }

  getOrganizationStatsForScouting(): Observable<any>{
    let ret = this.http.get<any>(this.rootUrl + '/api/scouting/reports/analysis/permonth');
    return ret;    
    
  }

  getOrganizationBirthyearStatsForScouting(seasonId: number): Observable<any>{
    let ret = this.http.get<any>(this.rootUrl + '/api/scouting/reports/analysis/birthyear/' + seasonId);
    return ret;    
    
  }

  
  getOrganizationEventStatsForScouting(seasonId: number): Observable<any>{
    let ret = this.http.get<any>(this.rootUrl + '/api/scouting/reports/analysis/events/' + seasonId);
    return ret;    
    
  }

  getOrganizationProjectionStatsForScouting(seasonId: number): Observable<any>{
    let ret = this.http.get<any>(this.rootUrl + '/api/scouting/reports/analysis/projection/' + seasonId);
    return ret;    
    
  }
  
  getOrganizationReportingForScoutsBySeason(seasonId: number): Observable<any>{
    let ret = this.http.get<any>(this.rootUrl + '/api/scouting/reports/analysis/byscout/' + seasonId);
    return ret;    
    
  }

  GetReportingGameDivisionCountBySeason(seasonId: number): Observable<any>{
    let ret = this.http.get<any>(this.rootUrl + '/api/scouting/reports/analysis/divisions/' + seasonId);
    return ret;    
    
  }
  
  GetScoutReportingLocationCount(seasonId: number): Observable<any>{
    let ret = this.http.get<any>(this.rootUrl + '/api/scouting/reports/analysis/locations/' + seasonId);
    return ret;        
  }


}
